export default {
  'booking.totalsales': 'Vendite totali per contatore',
  'booking.buy_ticket': 'Compra Biglietto',
  'booking.wheretogo': 'Dove vorresti andare?',
  'booking.searchflight': 'Cerca il Volo',
  'booking.selectflight': 'Scegli il Volo',
  'booking.oneway': 'Senso unico',
  'booking.onewaytrip': 'viaggio di sola andata',
  'booking.roundtrip': 'Andata e Ritorno',
  'booking.multicity': 'Più destinazioni',
  'booking.bestguarantee': 'Le Migliori Tariffe Garantite Online',
  'booking.getdeals': 'Ottieni Offerte',
  'booking.signupnow': 'Scriviti Ora ',
  'booking.from': 'A',
  'booking.to': 'Per',
  'booking.guest': 'Ospite',
  'booking.city': 'Città',
  'booking.country': 'Paese',
  'booking.Adult': 'Adulti',
  'booking.adult': 'Adulti',
  'booking.Child': '(Age 2-12)	Bambini (Età 2-12)',
  'booking.Infant': '(Age 0-2)	Neonati (Età 0-2)',
  'booking.guestsandcities': 'Ospite e Città',
  'booking.startover': 'Ricomincia',
  'booking.showmoredate': 'Mostra più Date',
  'booking.selectdate': 'Seleziona la Data ',
  'booking.date': 'Data',
  'booking.changedate': 'Modifica Data',
  'booking.airline': 'Linea Aerea',
  'booking.departs': 'Partenze',
  'booking.arrives': 'Arrivi',
  'booking.duration': 'Durata',
  'booking.travelclass': 'Classe',
  'booking.priceperadult': 'Prezzo Adulti ',
  'booking.priceperchild': 'Prezzo Bambini',
  'booking.priceperinfant': 'Prezzo Neonati',
  'booking.flightnumber': 'NUMERO DEL VOLO',
  'booking.remainseat': 'Posti Liberi',
  'booking.cost': 'Costo',
  'booking.showmore': 'Mostra di Più',
  'booking.birthyear': 'Anno di Nascita',
  'booking.birthmonth': 'Mese di Nascita',
  'booking.birthday': 'Giorno di Nascita',
  'booking.passportno': 'Numero di Passaporto',
  'booking.birthcountry': 'Paese di Nascita',
  'booking.passportcountry': 'Nazionalità',
  'booking.passportexpireyear': 'Anno di  Scadenza ',
  'booking.passportexpiremonth': 'Mese di  Scadenza ',
  'booking.passportexpireday': 'Giorno di  Scadenza ',
  'booking.completeform': 'Completa il modulo per continuare',
  'booking.changeavatar': 'Modifica Avatar',
  'booking.passengerinfo': 'Informazione sui Viagiatori',
  'booking.isiranian': 'Iraniano',
  'booking.othernationality': 'Altre Nazionalità',
  'booking.previouspassenger': 'Seleziona tra la Lista dei Viaggiatori',
  'booking.index': 'Indice',
  'booking.primarytraveler': 'Viaggiatore Principale',
  'booking.adultinformation': 'Informazione su Adulti',
  'booking.childinformation': 'Informazione su Bambni',
  'booking.infantinformation': 'Informazione su Neonati',
  'booking.phone': 'Numero di Telefono',
  'booking.totalprice': 'Prezzo Totale',
  'booking.stopcount': 'Stop',
  'booking.airplanetype': 'Aereo',
  'booking.international': 'Internazionale',
  'booking.domestic': 'Domestico',
  'booking.notexist': 'NON ESISTE',
  'booking.noavailableflight': 'NESSUN VOLO DISPONIBILE ',
  'booking.departurecities': 'Città di Partenza',
  'booking.returncities': 'Città di Ritorno',
  'booking.departuredate': 'Data di Partenza',
  'booking.returndate': 'di Ritorno',
  'booking.departuretime': 'Ora di Parteza',
  'booking.previousepassengerlist': 'lista passeggeri precedente',
  'booking.returntime': 'Ora di Ritorno',
  'booking.paynow': 'Paga Ora',
  'booking.sigin': 'Registrati',
  'booking.signup': 'Sign Up',
  'booking.notregister': 'Non Registrato',
  'booking.elevatemembers': 'Eleva i Membri',
  'booking.departureflightinfo': 'Informazioni sulla Partenza',
  'booking.returnflightinfo': 'Informazioni sul Ritorno',
  'booking.hi': 'Ciao',
  'booking.travelwith': 'Viaggia con ',
  'booking.ticket': 'Il tuo biglietto sarà emesso presto',
  'booking.successpayment': 'Il tuo pagamento è andato a buon fine',
  'booking.previousepassengerlis': 'Elenco Viaggiatori Precedenti ',
  'booking.bookingflights': 'Prenotazione Voli',
  'booking.flightno': 'Numero del Volo ',
  'booking.child': 'Bambini',
  'booking.infant': 'Neonati',
  'booking.male': 'Maschile ',
  'booking.female': 'Femminile',
  'booking.departureflight': 'Volo di Partenza',
  'booking.returnflight': 'Volo di Ritorno',
  'booking.showticket': 'Biglietto',
  'booking.cancel': 'Annulla',
  'booking.passengers': 'Viaggiatori',
  'booking.price': 'Prezzo',
  'booking.returnprice': 'Prezzo di Ritorno ',
  'booking.cancelstatus': 'Stato',
  'booking.cancelreason': 'Perché vuoi cancellare il tuo biglietto?',
  'booking.personalproblem':
    'Problema personale (Basato sulle Regole della Compagnia Aerea)',
  'booking.airlineproblem': 'Volo Cancellato dalla Compagna aAerea',
  'booking.flightproblem': 'Volo in Ritardo o in Anticipo Più di 2 Ore ',
  'booking.back': 'ndietro',
  'booking.nextstep': 'Passo Successivo',
  'booking.cancelingrules': 'Annullamento delle Regole',
  'booking.wait': 'Attendere Prego  ......',
  'booking.flights': 'Voli',
  'booking.cancelpayment': 'Transazione Non Riuscita',
  'booking.refid': 'Tuo tracking code è: ',
  'booking.airport': 'Aeroporti',
  'booking.flighttime': 'Ora del Volo',
  'booking.flightstopcount': 'Fermate',
  'booking.morning': 'Mattina (0 fino alle 8)',
  'booking.noon': 'Mezzogiorno (dalle 8 alle 14)',
  'booking.afternoon': 'Pomeriggio (dalle 14 alle 20)',
  'booking.sort': 'Ordinamento',
  'booking.sortbyprice': 'Per Prezzo ',
  'booking.sortbytime': 'Per Ora ',
  'booking.nonstop': 'Diretta',
  'booking.onestop': 'Una Fermata',
  'booking.morethanonestop': 'Più di una Fermata',
  'booking.origin': 'Origine',
  'booking.destination': 'Destinazione',
  'booking.startdate': "Data d'inizio",
  'booking.enddate': 'Data di fine',
  'booking.search': 'Cerca',
  'booking.filter': 'Filtro',
  'booking.agree': "Sono d'Accordo",
  'booking.cancelrules': 'Annulla le Regole',
  'booking.flightscount': 'Voli Trovati!',
  'booking.clearfilter': 'Chiaro',
  'booking.gifavatar': 'Gif Avatar',
  'booking.avatar': 'Avatar',
  'booking.notfound': 'Nessuna città trovata',
  'booking.nextyear': "L'Anno Prossimo",
  'booking.previousyear': "L'Anno Scorso",
  'booking.details': 'Dettagli',
  'booking.adultprice': 'Prezzo per Adulti',
  'booking.sortby': 'Ordina Per',
  'booking.Child (Age 2-12)': 'Bambino (età 2 - 12)',
  'booking.Infant (Age 0-2)': 'Neonato (età 0 - 2)',
  'booking.bydescendingprice': 'Prezzo',
  'booking.byascendingduration': 'Durata',
  'booking.bydescendingduration': 'Durata',
  'booking.bydescendingpoint': 'Punto',
  'booking.byascendingpoint': 'Punto',
  'booking.byascendingprice': 'Prezzo',
  'booking.bydescendingtime': 'Ora di partenza',
  'booking.byascendingtime': 'Ora di Partenza',
  'booking.byascendingarrivetime': 'Ora di Arrivo',
  'booking.bydescendingarrivetime': 'Ora di Arrivo',
  'booking.justthis': 'Solo',
  'booking.searchpassenger': 'Stai cercando...',
  'booking.edit': 'Modifica',
  'booking.select': 'Seleziona',
  'booking.gotoday': 'Vai Oggi',
  'booking.pricedetail': 'Dettagli del Prezzo',
  'booking.passengertype': 'Tipo ',
  'booking.fareprice': 'Tariffa',
  'booking.tax': 'Tasse',
  'booking.allairport': ' ( Tutti Aeroporti )',
  'booking.moneyunit': '(Tutti i Prezzi sono in $)',
  'booking.noseatresult': 'nessun posto',
  'booking.today': 'Oggi',
  'booking.terminal': 'Terminale',
  'booking.sumprice': 'Prezzo Totale',
  'booking.sameairport': "Per favore inserisci un unico 'Da' e 'A' aeroporto.",
  'booking.stopin': 'Frmarsi a',
  'booking.megaleapyearsale': "Mega Vendita dell'Anno",
  'booking.planasunnyd1':
    'Pianifica subito una vacanza al sole e risparmia con',
  'booking.planasunnyd2': 'tariffe super rare con uno sconto del 29%.',
  'booking.restrictionsapply': 'Restrizioni di iscrizione',
  'booking.grabaseat': 'SCEGLI IL TUO POSTO A SEDERE',
  'booking.enjoywithbestfriends': 'Divertiti con i tuoi migliori amici;',
  'booking.helpafriendd1':
    'Aiuta un amico a completare con il suo programma fedeltà',
  'booking.helpafriendd2': 'e segna punti Elevati',
  'booking.termsandconditionsapply': 'I termini e condizioni applicati',
  'booking.bookhotels': 'Prenota Hotel',
  'booking.booktours': 'Touren buchen',
  'booking.traveldate': 'Data di viaggio',
  'booking.invoice': 'Fattura',
  'booking.totalamount': 'Prezzo Totale',
  'booking.showreserve': 'Mostra riserva',
  'booking.takeofffaster': 'Decolla Più Velocemente',
  'booking.earn10kpointsd1': 'Guadagna 10K punti con un IAM TOURIST',
  'booking.earn10kpointsd2': 'Carta Visa Signature .',
  'booking.learnmore': 'IMPARA DI PIÙ',
  'booking.swipeforthesky': 'Cogli al Volo',
  'booking.getsetforamorerewardingexperienceonthegroundandinthesky':
    "Preparati per un'esperienza più gratificante sulla terra e nel cielo con la nuova carta Visa Signature® IAM TOURIST.",
  'booking.firstoneonfirstoneoff': 'IL PRIMO ON, IL PRIMO OFF',
  'booking.inahurry':
    "Hai fretta? Crea una linea B per l'auto con un posto di cabina principale preferito verso la parte anteriore dell'aereo, oppure concediti la sicurezza e l'imbarco prioritario con una piccola tassa.",
  'booking.feeltheupgrade': "SENTI L'AGGIORNAMENTO.",
  'booking.travelinstylewithextralegroom':
    'Viaggia con stile con maggiore spazio per le gambe, imbarco prioritario e sicurezza e altro ancora in Main Cabin selezionato. Vivilo bene, molto bene.',
  'booking.takethefasttrack': 'SCEGLI FAST TRACK',
  'booking.breezethroughsecuritylikeyouowntheplace':
    'Vola attraverso la sicurezza come se fossi il proprietario del posto con lo screening accelerato di TSA Pre✓ ™. Scopri come usufruire dei vantaggi.',
  'booking.corporaterewards': 'PREMI AZIENDALI',
  'booking.abetterflighttoyournextmeetingdoesn’thavetobeanextravagance':
    'Un volo migliore per la prossima riunione non deve essere una stravaganza. Elevate, Inc., è il nostro programma di premi aziendali che restituisce alla tua attività qualcosa in cambio di ciò che spendi in viaggio.',
  'booking.packyourpoints': 'COLLEZIONA I TUOI PUNTI.',
  'booking.livelargeat35,000feet':
    'Vivi in grande a 35.000 piedi. Unisciti a Elevate e inizia a accumulare punti, vantaggi e premi voli con no blackout dates.',
  'booking.allpassengerprice': 'Prezzo Totale Per Tutti i Viaggiatori',
  'booking.baggages': 'Bagagli',
  'booking.orderdate': "Data dell'Ordine",
  'booking.passengername': 'Nome',
  'booking.cancelticket': 'ANNULLA BIGLIETTO',
  'booking.operatedairline': 'Compagnia Aerea Gestita',
  'booking.count': 'Conteggia',
  'booking.departureflighttime': 'Ora di Partenza',
  'booking.returnflighttime': 'Ora di Ritorno',
  'booking.returnstopcount': 'Fermate di Ritorno',
  'booking.pc': 'PC',
  'booking.kg': 'KG',
  'booking.cabin': 'Cabina',
  'booking.layoverairports': 'Aeroporti di Sosta',
  'booking.includeairports': 'Aeroporti Inclusi',
  'booking.departduration': 'Durata di Partenza',
  'booking.returnduration': 'Durata di Ritorno',
  'booking.night': 'notte (dopo le 20)',
  'booking.nightcount': 'Notte',
  'booking.nights': 'Notti',
  'booking.showflightdetail': 'Mostra i dettagli del volo',
  'booking.toman': '$',
  'booking.free': 'Gratuito',
  'booking.hour': 'Ore',
  'booking.minutes': 'Minuti',
  'booking.and': 'e',
  'booking.nobaggage': 'Nessun Bagaglio',
  'booking.mainterminal': 'Terminale principale',
  'booking.shamsi': 'jalali',
  'booking.miladi': 'gregoriano',
  'booking.adultageerror': "l'età di adulti dovrebbe essere più di 12 anni",
  'booking.childageerror':
    "l'età dei bambini dovrebbe essere più di 2 anni e meno di 12 anni",
  'booking.infantageerror': "l'età del neonato dovrebbe essere meno di 2 anni",
  'booking.passenger': 'Viaggiatore',
  'booking.important': 'Importante',
  'booking.identifynote':
    'Il nome completo dei passeggeri deve essere scritto in inglese esattamente come appare sul passaporto.',
  'booking.validpassportdate':
    'La data di scadenza del passaporto deve essere superiore a 6 mesi.',
  'booking.adt': 'ADT',
  'booking.chd': 'CHD',
  'booking.inf': 'INF',
  'booking.departure': 'Partenza',
  'booking.return': 'Ritorno',
  'booking.allflightinformation': 'Tutte le informazioni sul volo',
  'booking.notavailable': 'N/A',
  'booking.previousemonth': 'Mese Precedente',
  'booking.nextmonth': 'Mese Successivo',
  'booking.passportexpiredate': 'Data di Scadenza del Passaporto',
  'booking.arrivein': 'Arrivo a',
  'booking.nextdays': 'Giorno Successivo',
  'booking.clearallfilter': 'Cancella tutto',
  'booking.duplicatepassenger	':
    'Il Codice Nazionale o il Numero del Passaporto Sono Duplicati',
  'booking.policy':
    'Controlla qui per indicare di aver letto e accettato I termini di',
  'booking.changecontact':
    'Le informazioni sul biglietto verranno inviate a : ',
  'booking.customeragreement': 'Contratto del Cliente',
  'booking.flightrules': 'Regole di Volo',
  'booking.changecontacttitle': 'Modifica le Informazioni di Contatto',
  'booking.fullname': 'Nome e Cognome',
  'booking.address': 'Indirizzo',
  'booking.changecontatc': 'Modifica',
  'booking.firstname': 'Nome',
  'booking.lastname': 'Cognome',
  'booking.departureairport': 'Aeroporto di Partenza',
  'booking.arrivalairport': 'Aeroporto di Arrivo',
  'booking.previousedays': 'Giorno Precedente',
  'booking.day': 'Giorno',
  'booking.month': 'Mese',
  'booking.year': 'Anno',
  'booking.changepassenger': 'Cambia Numero Viaggiatori',
  'booking.editdepartcity': 'Modifica Città di Origine',
  'booking.editdestinationcity': 'Modifica Città di Destinazione',
  'booking.editdepartdate': 'Modifica Data di Origine',
  'booking.editdestinationdate': 'Modifica Data di Destinazione',
  'booking.changepassengernotify':
    'Se cambi viaggiatore in questo passaggio, tornerai alla fase di ricerca del volo !!!!',
  'booking.edittooltip':
    'Per favore, clicca sulla proprietà desiderata per modificare le proprietà del volo',
  'booking.books': 'Prenotamenti',
  'booking.reserves': 'Prenotamenti',
  'booking.of': 'di',
  'booking.canceled': 'Cacellato',
  'booking.history': 'Storia',
  'booking.searchpassengerinfo':
    "Nome, Numero di Passaporto, Codice Nazionale, Numero d'ordine, Numero del biglietto, PNR",
  'booking.issued': 'Emesso',
  'booking.bought': 'Emesso',
  'booking.serviceType': 'Tipo di Servizio',
  'booking.serviceName': 'Volo, Hotel, Treno …',
  'booking.invoicenumber': 'Numero di Fattura',
  'booking.chooseticket': 'Quale biglietto vuoi cancellare?',
  'booking.cancelreturn': 'Annulla Solo Biglietto di Ritorno',
  'booking.cancelroundtrip': 'Anulla Tutti I Biglietti',
  'booking.addflight': 'Aggiungi Volo',
  'booking.showmulticity': 'Mostra Tutti i Voli',
  'booking.view': 'Visualizza',
  'booking.takeofffrom': 'Ora di decollo da',
  'booking.at': 'a',
  'booking.tripsi': 'Tripsi',
  'booking.includetax':
    'Il prezzo include le tasse e tutti i costi delle compagnie aeree',
  'booking.paymentsummery': 'Riepilogo Pagamenti',
  'booking.counter': 'Impiegato dello Sportello',
  'booking.sum': 'Somma',
  'booking.transaction': 'Rapporto sulle Transazioni',
  'booking.countercommission':
    "Rapporto della Commissione del'impiegato dello sportello",
  'booking.domesticflightscount': 'Numero dei Voli Nazionali',
  'booking.internationalflightscount': 'Numero dei Voli Internazionali',
  'booking.createdate': 'Crea Data',
  'booking.income': 'Reddito',
  'booking.notwithdrawincome': 'Non ritiro reddito',
  'booking.notwithdrawpoint': 'Non ritiro punto',
  'booking.withdrableincome': 'Reddito ritirabile',
  'booking.withdrablepoint': 'Punto ritirabile',
  'booking.pendingincome': 'Reddito in sospeso',
  'booking.pendingpoint': 'Punto in sospeso',
  'booking.collectedpoint': 'Punto raccolto',
  'booking.spentpoint': 'Punto speso',
  'booking.paymentstatus': 'Stato del Pagamento',
  'booking.withdrawdate': 'Data di Prelievo',
  'booking.countername': "Nome dell'Impiegato",
  'booking.canceledittin': 'Anulla',
  'booking.nationalcode': 'Nazionale',
  'booking.previousweek': 'Settimana Precedente',
  'booking.nextweek': 'Prossima Settimana',
  'booking.allprice': 'tutti i prezzi sono in IRT',
  'booking.allpriceisrial': 'tutti i prezzi sono in IRR',
  'booking.showallcalendar': 'mostra prezzo matrice',
  'booking.hideallcalendar': 'nascondi prezzo matrice',
  'booking.multicitytrip': 'Viaggio in Più Città',
  'booking.selectstakeholder': 'Scegli il Tuo Azionista',
  'booking.changestakeholder': 'Cambia il tuo Azionista',
  'booking.ticketwithoutprice': 'Biglietto Senza Prezzo',
  'booking.markupticket': 'Biglietto con Maggiorazione',
  'booking.orginalticket': 'Biglietto Originale',
  'booking.markup': 'Maggiorazione',
  'booking.removeflight': 'Rimuovi il volo',
  'booking.continueguest': 'Continua come ospite',
  'booking.hotel': 'Hotel',
  'booking.trackorder': 'Traccia gli Ordini',
  'booking.trackingcode': 'Tracking Code',
  'booking.searchyourorders': 'Cerca i tuoi ordini',
  'booking.panel': 'Pannello',
  'booking.required': 'NECESSARIO',
  'booking.baggagerules': 'Regole sui Bagagli',
  'booking.userpoint': 'Premio Drik',
  'booking.notresult': 'il tracking code non è valido',
  'booking.attachpassport': 'Carica passaporto ...',
  'booking.payhint': 'Per favore accetta le regole per continuare',
  'booking.completecontactdescription':
    "Per favore completa le informazioni di contatto dell'emittente del biglietto.",
  'booking.downloadticket': 'scarica il biglietto',
  'booking.updatepassenger': 'Aggiorna informazioni passeggero',
  'booking.paylater': 'paga dopo',
  'booking.pnr': 'PNR',
  'booking.penaltyprice': 'Penalty Price',
  'booking.sumcancelprice': 'Importo totale rimborsabile',
  'booking.paymenttype': 'Tipo di pagamento',
  'booking.chargecredit': 'addebita il mio credito',
  'booking.chargecreditinfo':
    "L'importo verrà addebitato sul credito di Tripsi per un massimo di 7 giorni lavorativi.",
  'booking.deposit': 'Deposito su carta bancaria',
  'booking.depositinfo':
    "L'importo verrà depositato sul conto bancario da cui è stato effettuato l'acquisto fino a un massimo di 7 giorni lavorativi.",
  'booking.cancelmessage':
    'La tua richiesta di cancellazione è stata inviata con successo ed è in corso',
  'booking.contactus':
    'Contatta il team di supporto di Tripsi in caso di problemi',
  'booking.sendproblem': 'Invia problema',
  'booking.notrefundable': 'Non rimborsabile',
  'booking.sendrequest': 'Invia richiesta',
  'booking.withdrawtype': 'Tipo di prelievo',
  'booking.hours': 'ore',
  'booking.before': 'prima del volo',
  'Booking.flight': 'volo',
  'booking.exacttime': 'a mezzogiorno',
  'Booking.until': 'fino a quando',
  'booking.afterflight': 'dopo il volo',
  'booking.beforeflight': 'prima del volo',
  'booking.after': 'fino a dopo',
  'booking.fromhours': 'dal',
  'booking.callsupport':
    "Si è verificato un errore durante l'emissione dei biglietti, contattare l'assistenza",
  'booking.nocancelrules': 'Regola di volo non trovata',
  'booking.andhigher': 'E più in alto',
  'booking.toprice': 'per',
  'booking.searchtimeout': 'Vuoi cercare di nuovo questo volo?',
  'booking.timeout': 'Tempo di ricerca ...',
  'booking.searchagaininfo': 'Il tempo per cercare questo',
  'booking.searchagaininfomsg': ' volo terminato',
  'booking.searchagian': 'sì',
  'booking.startagain': 'no',
  'booking.printticket': 'Stampa biglietto',
  'booking.retrivedocument': 'Recupero del documento...',
  'booking.forthepassenger': 'Per il passeggero',
  'booking.flightticket': 'Biglietto aereo',
  'booking.ticketno': 'Biglietto n',
  'booking.deptime': 'dep Time',
  'booking.cancelterm':
    '1- I termini di cancellazione per i voli CHARTER dipendono dalle regole del fornitore. Questo significa che potrebbe non essere mai cancellato.',
  'booking.cancelrulehint':
    '2- I costi di cancellazione dipendono dalle regole della compagnia aerea.',

  'booking.attention':
    'Attenzione: I passeggeri devono essere presenti in aeroporto 2 ore prima della partenza.',
  'booking.valididentify':
    "3- Avere con sé documenti di identità validi come carta d'identità nazionale, certificato di nascita o passaporto.",
  'booking.online': 'in linea',
  'booking.selectcountry': 'Seleziona il paese',
  'booking.calendar': 'calendario',
  'booking.countercommissionreport': 'Rapporto della contro Commissione',
  'booking.hasusername': 'hai un nome utente ?',
  'booking.nousername': 'Non ho un nome utente ?',
  'booking.signuporguest': '(Iscriviti o Utente ospite)',
  'booking.guestuser': 'Utente ospite',
  'booking.notuserbefore': 'Registrati ora e ottieni punti',
  'booking.reservationfail': 'Non è possibile prenotare questo volo',
  'booking.reservation':
    'Für diesen Flug ist eine temporäre Reservierung möglich',
  'booking.reservationerror': 'Prenotazione fallita!',
  'booking.passengererror': 'Passagierinformationsfehler !',
  'booking.passengerInformationHint':
    'Si prega di controllare le informazioni sui passeggeri...',
  'booking.displayticket': 'Come visualizzare i biglietti',
  'booking.selectcustomer': 'seleziona cliente',
  'booking.asacustomer': 'assegnare cliente',
  'booking.changeticketprice':
    'cambia la visualizzazione del prezzo del biglietto',
  'booking.save': 'Salva',
  'booking.fromwallet': 'Portafoglio',
  'booking.fromcredit': 'Credito',
  'booking.frompoint': 'Punto',
  'booking.usederik': 'Paga il prezzo del biglietto con il tuo derik',
  'booking.yourderik': 'il tuo derik : ',
  'booking.equivalentprice': 'Prezzo equivalente',
  'booking.importpnr': 'import PNR',
  'booking.pnrhint': 'seleziona il tuo sistema',
  'booking.pnrsteps': 'Per utilizzare PNR, eseguire questi passaggi',
  'booking.enteryour': '1- Enter to your Amadeus panel',
  'booking.openreference': '2- Make your reservation in Amadeus panel. ',
  'booking.pnr3': '3- Enter the passenger passport information completely. ',
  'booking.entercommand':
    '4-Enter the following command code and then press enter key. ',
  'booking.savepnr': '5-Save your PNR and press enter key. ',
  'booking.pnr6':
    '6- In Tripsi page, enter your PNR number in the reference number section. ',
  'booking.pnr7': '7- In the Passenger Last Name field, enter it. ',
  'booking.pnr8': '8- Click the booking button. ',
  'booking.pnr9': '9- Go to the payment page after checking the information. ',
  'booking.pnr10': '10- Your ticket has been issued. ',

  'booking.laststep':
    'Ora puoi inserire il tuo riferimento nella casella sottostante e seguire i passaggi di esportazione. ',
  'booking.leadlastname': 'Cognome del passeggero principale',
  'booking.buyer': 'Acquirente',
  'booking.pnrnotfound': 'Nessun articolo trovato',
  'booking.usepnr': 'Importa PNR e visualizza',
  'booking.uploadpassporterror':
    'Le informazioni sul passaporto non sono leggibili',
  'booking.servererror': 'Il server ha un problema',
  'booking.accessdenied': 'accesso negato',
  'booking.newpassenger': 'Aggiungi nuovo passeggero',
  'booking.errormorepassenger': 'Hai scelto più passeggeri',
  'booking.passengertypeerror': 'Tipo di passeggero non valido',
  'booking.chooseallpassenger': 'Scegli tutti i passeggeri',
  'booking.checkpassport':
    'Dopo aver caricato i dati del passaporto, controlla le tue informazioni.',
  'booking.apply': 'applicare',
  'booking.flightinformation': 'Informazioni di volo',
  'booking.adultticketprice': 'biglietto per adulti',
  'booking.childticketprice': 'biglietto bambino',
  'booking.infantticketprice': 'Biglietto per neonati',
  'booking.airplane': 'Aereo',
  'booking.time': 'tempo',
  'booking.invoiceno': 'No di Fattura',
  'booking.charter': 'carta',
  'booking.systemic': 'Sistemico',
  'booking.type': 'Tipo',
  'booking.paymentprice': 'Prezzo del biglietto',
  'booking.pnrcode': 'il tuo PNR è:',
  'booking.selectpayment': 'Seleziona il tipo di pagamento',
  'booking.temporaryreservation': 'Prenotazione',
  'booking.direction': 'Direzione',
  'booking.passengercount': 'Conta i passeggeri',
  'booking.reservesuccess':
    'Il tuo biglietto è stato prenotato temporaneamente',
  'booking.passengertotalprice': 'Prezzo totale passeggeri',
  'booking.stopduration': 'interrompere la durata',
  'booking.invalidbirthdate': 'data di nascita errata',
  'booking.invalidexpiredate': 'giorno di scadenza non valido',
  'booking.fullbirthdate': 'Seleziona completamente la data di nascita',
  'booking.fullexpiredate': 'Seleziona completamente la data di scadenza ',
  'booking.creditpayment': 'Il pagamento dal tuo credito è andato a buon fine',
  'booking.walletpatment':
    'Il pagamento dal tuo portafoglio è andato a buon fine',
  'booking.pointpayment': 'Il pagamento dal tuo punto è andato a buon fine',
  'booking.tickettimelimit': 'Limite di tempo del biglietto',
  'booking.onbehalf': 'a nome di',
  'booking.expirereserve': 'Scaduto',
  'booking.person': 'persona',
  'booking.startorderdate': 'Data di inizio ordine',
  'booking.endorderdate': 'Data di fine ordine',
  'booking.missflight': 'Ho perso il volo',
  'booking.multiairline': 'multi compagnia aerea',
  'booking.in': 'a',
  'booking.afterdiscount': 'Dopo lo sconto',
  'booking.editissuer': 'Modifica le informazioni di contatto del problema',
  'booking.referencenumber': 'numero di riferimento',
  'booking.train': 'treno',
  'booking.bus': 'autobus',
  'booking.economy': 'Economia',
  'booking.business': 'Attività commerciale',
  'booking.first': 'Prima',
  'booking.allcabinclasses':
    'Verranno visualizzate tutte le classi di volo sulla rotta selezionata.',
  'booking.selectacity': 'Seleziona una città',
  'booking.findtrip': 'trova viaggio',
  'booking.destinations': 'Destinazioni',
  'booking.london': 'London',
  'booking.rome': 'Roma',
  'booking.istanbul': 'Istanbul',
  'booking.deletePassengerTitle': 'Elimina passeggero',
  'booking.invalidnationalcode': 'Codice nazionale non valido',
  'booking.showgatewayerror': 'mostra errore gateway',
  'booking.alternativefrom': 'From',
  'booking.alternativeto': 'To',
  'booking.commingsoon': 'Presto',
  'booking.searchorigin': 'Origine della ricerca',
  'booking.searchdestination': 'Cerca destinazione',
  'booking.plannedflight': 'il volo selezionato',
  'booking.yesterday': 'Ieri',
  'booking.twodaysago': 'Due giorni fa',
  'booking.englishname': 'Nome (inglese)',
  'booking.englishlastname': 'Cognome (inglese)',
  'booking.rialtotalprice': 'Prezzo Totale(Rial)',
  'booking.gotosearchflight': 'Vai alla ricerca volo',
  'booking.seat': 'seat',
  'booking.englishticket': 'Versione inglese dei biglietti',
  'booking.persianticket': 'Versione persiana del biglietto',
  'booking.searchmypassenger': 'ricerca da passeggeri precedenti',
  'booking.selectairporterror': "Seleziona origine e destinazione dall'alto",
  'booking.providergateway': 'Gateway provider',
  'booking.seniorageerror':
    "L'età dei cittadini anziani deve essere superiore a 60 anni",
  'booking.toddlergeerror': "l'età del bambino deve essere inferiore a 2 anni",
  'booking.noresultwithfilter':
    'Nessun risultato trovato con il filtro selezionato, per favore cambialo',
  'booking.expirereservation': 'Prenotazione scaduta',
  'booking.unpaidreservation': 'prenotazioni non pagate',
  'booking.selectbooking': 'Si prega di selezionare i biglietti per pagare',
  'booking.mobileformaterror': 'Il formato per dispositivi mobili non è valido',
  'booking.tickettitle': 'biglietto :',
  'booking.poweredby': 'Powered by',
  'booking.hoteldescription': 'Prenota ora il tuo hotel con uno sconto del 30%',
  'booking.tourdescription':
    'Tour europeo di 21 giorni per Nowruz 1401. Iscrizioni fino a fine dicembre 5% di sconto',
  'booking.parishotel': 'Paris Hotel',
  'booking.stopdurationin': 'Durata sosta tra',
  'booking.contactInfo': 'Fornire informazioni di contatto',
  'booking.expireDate': 'Data di scadenza',
  'booking.pnrdesc': 'Prenota in Amadeus e pubblica qui.',
  'booking.officeid': 'ID ufficio',
  'booking.pnrhelp': "Manuale d'uso",
  'booking.ticketinfo': 'Dettagli sui biglietti',
  'booking.saletotalamount': 'Importo totale vendita',
  'booking.traveldatetime': 'Data di viaggio',
  'booking.sale': 'Sale',
  'booking.buy': 'Buy',
  'booking.emailticket': 'E-mail ticket',
  'booking.changeticketprice': 'Cambia prezzo',
  'booking.backpreviouspage': 'Torna alla pagina precedente',
  'booking.changecabinclass': 'Cambia classe di cabina',
  'booking.changecabinclassnotify':
    'Se cambi classe di cabina in questa fase tornerai alla fase di ricerca del volo!!!!',
  'booking.ticketprice': 'Prezzo del biglietto',
  'booking.payableamount': 'importo da pagare',
  'booking.showflight': 'Mostra volo',
  'booking.tripdirection': 'Direzione di viaggio',
  'booking.selectpaymenttype': 'Seleziona tipo di pagamento',
  'booking.title': 'Titolo',
  'booking.yourchoice': 'La tua scelta',
  'booking.mr': 'Sig.',
  'booking.mrs': 'Signora',
  'booking.result': 'Risultato',
  'booking.changeflight': 'cambia rotta di volo',
  'booking.arrivetime': 'Orario di arrivo',
  'booking.sortbyarrivetime': 'Ordina per orario di arrivo',
  'booking.sortbyduration': 'Nach Dauer sortieren',
  'booking.sortbypoint': 'Ordina per punto',
  'booking.tickettype': 'Tipo di biglietto',
  'booking.selectall': 'Seleziona Tutto',
  'booking.addpassenger': 'Aggiungi passeggero',
  'booking.textpassenger':
    'Attraverso il modulo sottostante, puoi inserire le informazioni del tuo passeggero e registrare le informazioni alla fine.',
  'booking.showavailableflight': 'Mostra i voli disponibili',
  'booking.roomtype': 'tipo di stanza',
  'booking.extrabed': 'letto in più',
  'booking.numberofrooms': 'Numero di stanze',
  'booking.addnewroom': 'Aggiungi una nuova stanza',
  'booking.picturesofroom': 'Immagini della stanza',
  'booking.availsflight': 'volo disponibile',
  'booking.events': 'Eventi nel calendario',
  'booking.eventsinfo': 'Visualizza eventi di ogni paese selezionato',
  'booking.want': 'io voglio',
  'booking.setmaxprice': 'impostare il prezzo massimo',
  'booking.selectcity':
    'Per favore, seleziona prima gli aeroporti di origine e di destinazione',
  'booking.allcabinselected':
    'Nei voli nazionali verranno cercate tutte le classi di volo',
  'booking.all': 'Tutto',
  'booking.passportImage': 'Immagine del passaporto',
  'booking.passporthint':
    "Carica l'immagine in modo chiaro e secondo il campione nella dimensione 700*500",
  'booking.originCity': 'Città di origine',
  'booking.destinationCity': 'Città di destinazione',
  'booking.welcometripsi': 'Benvenuti a Tripsi',
  'booking.PassengerNameInEnglish': 'Nome del passeggero in inglese',
  'booking.PassengerLastNameInEnglish': 'cognome in inglese',
  'booking.NationalityOfThePassenger': 'Nazionalità del passeggero',
  'booking.genderOfThePassenger': 'Genere del passeggero',
  'booking.totalpriceofpassengers': ' Prezzo totale del passeggero ',
  'booking.travelerdetails': 'Dettagli del viaggiatore',
  'booking.senior': 'Anziano',
  'booking.toddler': 'neonato sedile',
  'booking.reservebefore': 'questo volo lo prenoti per te prima',
  'booking.editpassengersinfo': 'Modifica informazioni passeggeri'
};
